import { Qualifier, VariableSubType, VariableType, IVariableTypeFileModel } from '../../models';
import { IDispatcherService, IDispatcher } from '../';
import { IVariablesActionsService } from './variables.actionCreator';

export interface IVariablesStoreService {
    getVariableTypes(): angular.IPromise<VariableType[]>;
    getVariableTypes(force: boolean): angular.IPromise<VariableType[]>;
    getVariableSubTypes(): angular.IPromise<VariableSubType[]>;
    getVariableSubTypes(force: boolean): angular.IPromise<VariableSubType[]>;
    getQualifiers(): angular.IPromise<Qualifier[]>;
    getQualifiers(force: boolean): angular.IPromise<Qualifier[]>;
    updateAll(value: { variableTypes: VariableType[]; qualifiers: Qualifier[]; variableSubTypes: VariableSubType[]; });
}

export interface IVariablesActionDispatcherService extends IDispatcherService<IVariablesStoreService> { }

export class VariablesActionDispatcherService implements IVariablesActionDispatcherService {
    static serviceId = 'variablesActionDispatcherService';

    static $inject = ['variablesActionsService'];

    constructor(private _actionService: IVariablesActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IVariablesStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getVariableTypes: (force?: boolean) => dispatch(actionService.getVariableTypes(force)),
                getVariableSubTypes: (force?: boolean) => dispatch(actionService.getVariableSubTypes(force)),
                getQualifiers: (force?: boolean) => dispatch(actionService.getQualifiers(force)),
                updateAll: (value: IVariableTypeFileModel) => dispatch(actionService.updateAll(value)),
            }
        };
    }
}